import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import ClassetCalendar from '../../../classetComponents/classetCalender';
import Service from '../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import LoadingComponent from '../../loadingComponent';
import { format } from 'date-fns';
import '../transportStyles.scss';

class RouteVehicleAssignment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            currentServices: [],
            assignmentHistory: [],
            showAssignDialog: false,
            showChangeDialog: false,
            showConfirmUnassignDialog: false,
            selectedVehicleId: null,
            serviceName: '',
            startDate: new Date(),
            vehicleDropdown: [],
            activeTab: 'current',
            selectedServiceToRemove: null,
            studentCountToUnassign: 0,
            pendingApprovalCount: 0
        };
        this.service = new Service();
        this.toast = React.createRef();
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.routeId !== this.props.routeId || prevProps.visible !== this.props.visible) {
            if (this.props.visible && this.props.routeId) {
                this.loadData();
            }
        }
    }

    loadData = async () => {
        await Promise.all([
            this.getCurrentServices(),
            this.getAssignmentHistory(),
            this.getAvailableVehicles()
        ]);
    };

    getCurrentServices = async () => {
        const { routeId, branchId } = this.props;
        if (!routeId) return;

        this.setState({ isLoading: true });
        try {
            const academicYear = localStorage.getItem('userAcademicYear');
            const url = `${baseUrlAdmin}/transport-service/list`;
            const payload = {
                branchId,
                orgId: localStorage.getItem('orgId'),
                academicYear
            };
            const res = await this.service.post(url, payload, true);

            if (res?.res?.status && res.status) {
                // Filter services for this route
                const services = (res.res.data || []).filter(s => s.routeId?.toString() === routeId?.toString());
                this.setState({ currentServices: services });
            } else {
                this.setState({ currentServices: [] });
            }
        } catch (error) {
            console.error('Error loading current services:', error);
            this.setState({ currentServices: [] });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    getAssignmentHistory = async () => {
        const { routeId, branchId } = this.props;
        if (!routeId) return;

        try {
            const url = `${baseUrlAdmin}/transport-service/route/${routeId}/history?branchId=${branchId}`;
            const res = await this.service.get(url, true);

            if (res?.res?.status && res.status) {
                this.setState({ assignmentHistory: res.res.data || [] });
            }
        } catch (error) {
            console.error('Error loading assignment history:', error);
        }
    };

    getAvailableVehicles = async () => {
        const { branchId } = this.props;
        const academicYear = localStorage.getItem('userAcademicYear');

        try {
            const url = `${baseUrlAdmin}/transport-route/meta-data?academicYear=${academicYear}`;
            const payload = { branchId };
            const res = await this.service.post(url, payload, true);

            if (res?.res?.status && res.status) {
                const vehicles = (res.res.data.vehicles || []).map(vehicle => ({
                    label: `${vehicle.vehicleName} (${vehicle.vehicleRegistrationNo})`,
                    value: vehicle._id,
                    registrationNo: vehicle.vehicleRegistrationNo
                }));

                this.setState({ vehicleDropdown: vehicles });
            }
        } catch (error) {
            console.error('Error loading available vehicles:', error);
        }
    };

    handleCreateService = async () => {
        const { selectedVehicleId, startDate, serviceName } = this.state;
        const { routeId, branchId } = this.props;

        if (!selectedVehicleId) {
            this.toast.current?.show({
                severity: 'warn',
                summary: 'Validation Error',
                detail: 'Please select a vehicle',
                life: 3000
            });
            return;
        }

        if (!serviceName || !serviceName.trim()) {
            this.toast.current?.show({
                severity: 'warn',
                summary: 'Validation Error',
                detail: 'Please enter a service name',
                life: 3000
            });
            return;
        }

        this.setState({ isLoading: true });
        try {
            const url = `${baseUrlAdmin}/transport-service`;
            const academicYear = localStorage.getItem('userAcademicYear');
            const payload = {
                serviceName: serviceName.trim(),
                routeId,
                vehicleId: selectedVehicleId,
                branchId,
                orgId: localStorage.getItem('orgId'),
                academicYear,
                startDate: startDate || new Date()
            };

            const res = await this.service.post(url, payload, true);

            if (res?.res?.status && res.status) {
                this.toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Service created successfully',
                    life: 3000
                });
                this.setState({
                    showAssignDialog: false,
                    selectedVehicleId: null,
                    serviceName: '',
                    startDate: new Date()
                });
                await this.loadData();
            } else {
                throw new Error(res?.errMessage || res?.res?.errMessage || 'Service creation failed');
            }
        } catch (error) {
            this.toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'Failed to create service',
                life: 5000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    handleChangeVehicle = async () => {
        const { selectedVehicleId, startDate } = this.state;
        const { routeId } = this.props;

        if (!selectedVehicleId) {
            this.toast.current?.show({
                severity: 'warn',
                summary: 'Validation Error',
                detail: 'Please select a vehicle',
                life: 3000
            });
            return;
        }

        this.setState({ isLoading: true });
        try {
            const url = `${baseUrlAdmin}/route-vehicle-assignment/change`;
            const branchId = localStorage.getItem('userBranchId');
            const academicYear = localStorage.getItem('userAcademicYear');
            const payload = {
                routeId,
                newVehicleId: selectedVehicleId,
                branchId,
                academicYear,
                effectiveDate: startDate || new Date()
            };

            const res = await this.service.post(url, payload, true);

            if (res?.res?.status && res.status) {
                this.toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Vehicle changed successfully',
                    life: 3000
                });
                this.setState({
                    showChangeDialog: false,
                    selectedVehicleId: null,
                    startDate: new Date()
                });
                await this.loadData();
            } else {
                throw new Error(res?.errMessage || res?.res?.message || 'Change failed');
            }
        } catch (error) {
            this.toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'Failed to change vehicle',
                life: 5000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    handleRemoveService = async (serviceId) => {
        this.setState({ isLoading: true });
        try {
            const url = `${baseUrlAdmin}/transport-service/${serviceId}/student-count`;
            const res = await this.service.get(url, true);

            if (res?.res?.status && res.status) {
                const { studentCount, hasStudents, pendingApprovalCount, hasPendingApprovals } = res.res.data;

                if (hasStudents || hasPendingApprovals) {
                    this.setState({
                        showConfirmUnassignDialog: true,
                        selectedServiceToRemove: serviceId,
                        studentCountToUnassign: studentCount,
                        pendingApprovalCount: pendingApprovalCount
                    });
                } else {
                    await this.removeService(serviceId, false, false);
                }
            }
        } catch (error) {
            this.toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'Failed to check service impact',
                life: 5000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    removeService = async (serviceId, confirmUnassignStudents, confirmAutoRejectApprovals) => {
        this.setState({ isLoading: true });
        try {
            const url = `${baseUrlAdmin}/transport-service/${serviceId}/deactivate`;
            const payload = { confirmUnassignStudents, confirmAutoRejectApprovals };

            const res = await this.service.post(url, payload, true);

            if (res?.res?.status && res.status) {
                this.toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Service removed successfully',
                    life: 3000
                });
                this.setState({
                    showConfirmUnassignDialog: false,
                    selectedServiceToRemove: null,
                    studentCountToUnassign: 0,
                    pendingApprovalCount: 0
                });
                await this.loadData();
            } else {
                throw new Error(res?.errMessage || res?.res?.errMessage || 'Removal failed');
            }
        } catch (error) {
            this.toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'Failed to remove service',
                life: 5000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    handleRemoveVehicle = () => {
        confirmDialog({
            message: 'Are you sure you want to remove the vehicle from this route?',
            header: 'Confirm Removal',
            icon: 'pi pi-exclamation-triangle',
            accept: () => this.removeVehicle(),
            reject: () => { }
        });
    };

    handleRemoveSpecificVehicle = (assignmentId) => {
        confirmDialog({
            message: 'Are you sure you want to remove this vehicle from the route?',
            header: 'Confirm Removal',
            icon: 'pi pi-exclamation-triangle',
            accept: () => this.removeSpecificVehicle(assignmentId),
            reject: () => { }
        });
    };

    removeSpecificVehicle = async (assignmentId) => {
        this.setState({ isLoading: true });
        try {
            const url = `${baseUrlAdmin}/route-vehicle-assignment/remove`;
            const payload = { assignmentId };

            const res = await this.service.post(url, payload, true);

            if (res?.res?.status && res.status) {
                this.toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Vehicle removed successfully',
                    life: 3000
                });
                await this.loadData();
            } else {
                throw new Error(res?.errMessage || res?.res?.message || 'Removal failed');
            }
        } catch (error) {
            this.toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'Failed to remove vehicle',
                life: 5000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    removeVehicle = async () => {
        const { routeId } = this.props;

        this.setState({ isLoading: true });
        try {
            const url = `${baseUrlAdmin}/route-vehicle-assignment/remove`;
            const payload = { routeId };

            const res = await this.service.post(url, payload, true);

            if (res?.res?.status && res.status) {
                this.toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Vehicle removed successfully',
                    life: 3000
                });
                await this.loadData();
            } else {
                throw new Error(res?.errMessage || res?.res?.message || 'Removal failed');
            }
        } catch (error) {
            this.toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'Failed to remove vehicle',
                life: 5000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    renderVehicleName = (rowData) => {
        const vehicle = rowData.vehicleId;
        return vehicle ? `${vehicle.vehicleName} (${vehicle.vehicleRegistrationNo})` : 'N/A';
    };

    renderDate = (rowData, field) => {
        const date = rowData[field];
        return date ? format(new Date(date), 'dd MMM yyyy') : 'N/A';
    };

    renderStatus = (rowData) => {
        return (
            <span className={`p-tag ${rowData.isActive ? 'p-tag-success' : 'p-tag-secondary'}`}>
                {rowData.isActive ? 'Active' : 'Inactive'}
            </span>
        );
    };

    renderAssignDialogFooter = () => {
        return (
            <div>
                <Button
                    label="Cancel"
                    icon="pi pi-times"
                    onClick={() => this.setState({ showAssignDialog: false, serviceName: '', selectedVehicleId: null })}
                    className="p-button-text"
                />
                <Button
                    label="Create Service"
                    icon="pi pi-check"
                    onClick={this.handleCreateService}
                    autoFocus
                />
            </div>
        );
    };

    renderChangeDialogFooter = () => {
        return (
            <div>
                <Button
                    label="Cancel"
                    icon="pi pi-times"
                    onClick={() => this.setState({ showChangeDialog: false })}
                    className="p-button-text"
                />
                <Button
                    label="Change Vehicle"
                    icon="pi pi-check"
                    onClick={this.handleChangeVehicle}
                    className="p-button-warning"
                    autoFocus
                />
            </div>
        );
    };

    render() {
        const { visible, onHide, routeName } = this.props;
        const {
            isLoading,
            currentServices,
            assignmentHistory,
            showAssignDialog,
            showChangeDialog,
            showConfirmUnassignDialog,
            selectedVehicleId,
            serviceName,
            startDate,
            vehicleDropdown,
            activeTab,
            studentCountToUnassign,
            selectedServiceToRemove,
            pendingApprovalCount
        } = this.state;

        return (
            <>
                <Toast ref={this.toast} />
                <ConfirmDialog />

                <Dialog
                    visible={visible}
                    style={{ width: '90vw', maxWidth: '1200px' }}
                    header={`Manage Services - ${routeName || 'Route'}`}
                    modal
                    onHide={onHide}
                    maximizable
                >
                    {isLoading && <LoadingComponent />}

                    <div className="mb-4">
                        <div className="flex gap-2">
                            <Button
                                label="Create Service"
                                icon="pi pi-plus"
                                onClick={() => this.setState({ showAssignDialog: true })}
                                className="p-button-success"
                            />
                            <Button
                                label="Current Services"
                                icon="pi pi-car"
                                onClick={() => this.setState({ activeTab: 'current' })}
                                className={activeTab === 'current' ? '' : 'p-button-outlined'}
                            />
                            <Button
                                label="History"
                                icon="pi pi-history"
                                onClick={() => this.setState({ activeTab: 'history' })}
                                className={activeTab === 'history' ? '' : 'p-button-outlined'}
                            />
                        </div>
                    </div>

                    {activeTab === 'current' ? (
                        currentServices && currentServices.length > 0 ? (
                            <div>
                                <h3 className="mt-0 mb-3">Active Services ({currentServices.length})</h3>
                                <div className="grid">
                                    {currentServices.map((service, index) => (
                                        <div key={service._id || index} className="col-12 md:col-6 lg:col-4">
                                            <div className="surface-card shadow-2 p-4 border-round">
                                                <div className="flex justify-content-between align-items-center mb-3">
                                                    <h4 className="m-0">{service.serviceName}</h4>
                                                    <Button
                                                        icon="pi pi-times"
                                                        className="p-button-rounded p-button-text p-button-danger"
                                                        onClick={() => this.handleRemoveService(service._id)}
                                                        tooltip="Remove this service"
                                                    />
                                                </div>
                                                <div className="mb-2">
                                                    <p className="text-600 mb-1">Vehicle</p>
                                                    <p className="font-bold text-lg">{service.vehicle?.vehicleRegistrationNo || 'N/A'}</p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="text-600 mb-1">Route</p>
                                                    <p className="font-bold">{service.route?.routeName || 'N/A'}</p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="text-600 mb-1">Vehicle Capacity</p>
                                                    <p className="font-bold">{service.vehicle?.seatingCapacity || 'N/A'}</p>
                                                </div>
                                                <div className="mb-2">
                                                    <p className="text-600 mb-1">Created On</p>
                                                    <p className="font-bold">{this.renderDate(service, 'startDate')}</p>
                                                </div>
                                                <div>
                                                    <p className="text-600 mb-1">Status</p>
                                                    {this.renderStatus(service)}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <div className="text-center p-5">
                                <i className="pi pi-car" style={{ fontSize: '3rem', color: '#ccc' }}></i>
                                <h3 className="text-600">No Services Created</h3>
                                <p className="text-500">Click "Create Service" to create a service (Route + Vehicle combination)</p>
                            </div>
                        )
                    ) : (
                        <DataTable
                            value={assignmentHistory}
                            emptyMessage="No assignment history"
                            showGridlines
                            className="transport-table-center"
                            paginator
                            rows={10}
                        >
                            <Column field="serviceName" header="Service Name" style={{ width: '25%' }} />
                            <Column field="vehicleId" header="Vehicle" body={this.renderVehicleName} style={{ width: '25%' }} />
                            <Column field="startDate" header="Start Date" body={(rowData) => this.renderDate(rowData, 'startDate')} style={{ width: '15%' }} />
                            <Column field="endDate" header="End Date" body={(rowData) => this.renderDate(rowData, 'endDate')} style={{ width: '15%' }} />
                            <Column field="isActive" header="Status" body={this.renderStatus} style={{ width: '20%' }} />
                        </DataTable>
                    )}
                </Dialog>

                {/* Confirm Unassign Dialog */}
                <Dialog
                    visible={showConfirmUnassignDialog}
                    style={{ width: '480px' }}
                    header="Confirm Service Removal"
                    modal
                    onHide={() => this.setState({ showConfirmUnassignDialog: false, selectedServiceToRemove: null, pendingApprovalCount: 0 })}
                >
                    <div className="text-center p-3">
                        <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem', color: '#f59e0b' }}></i>
                        <h3 className="mt-3">Confirm Deactivation</h3>

                        {pendingApprovalCount > 0 && (
                            <div className="mb-3 p-3 border-round" style={{ background: '#fef3c7', border: '1px solid #f59e0b' }}>
                                <p className="text-lg m-0">
                                    <strong>{pendingApprovalCount}</strong> pending transport approval request{pendingApprovalCount > 1 ? 's are' : ' is'} linked to this service.
                                </p>
                                <p className="text-600 mt-2 mb-0">
                                    These will be <strong>auto-rejected</strong> with reason "Service was deactivated".
                                    Affected students will need to re-submit their requests.
                                </p>
                            </div>
                        )}

                        {studentCountToUnassign > 0 && (
                            <div className="mb-3 p-3 border-round" style={{ background: '#fee2e2', border: '1px solid #ef4444' }}>
                                <p className="text-lg m-0">
                                    <strong>{studentCountToUnassign}</strong> student{studentCountToUnassign > 1 ? 's are' : ' is'} currently assigned to this service.
                                </p>
                                <p className="text-600 mt-2 mb-0">
                                    They will be <strong>unassigned from transport</strong> on deactivation.
                                </p>
                            </div>
                        )}

                        <p className="text-600 mt-3">Are you sure you want to proceed?</p>
                        <div className="flex justify-content-center gap-3 mt-4">
                            <Button
                                label="Cancel"
                                icon="pi pi-times"
                                onClick={() => this.setState({ showConfirmUnassignDialog: false, pendingApprovalCount: 0 })}
                                className="p-button-text"
                            />
                            <Button
                                label="Confirm & Deactivate"
                                icon="pi pi-check"
                                onClick={() => this.removeService(selectedServiceToRemove, studentCountToUnassign > 0, pendingApprovalCount > 0)}
                                className="p-button-danger"
                            />
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    visible={showAssignDialog}
                    style={{ width: '450px' }}
                    header="Create New Service"
                    modal
                    footer={this.renderAssignDialogFooter()}
                    onHide={() => this.setState({ showAssignDialog: false, serviceName: '', selectedVehicleId: null })}
                >
                    <div className="p-fluid">
                        <div className="field mb-3">
                            <label htmlFor="serviceName">Service Name *</label>
                            <input
                                id="serviceName"
                                type="text"
                                className="p-inputtext p-component w-full"
                                value={serviceName}
                                onChange={(e) => this.setState({ serviceName: e.target.value })}
                                placeholder="e.g., Morning Service A, Route 1 Bus"
                            />
                        </div>

                        <div className="field mb-3">
                            <label htmlFor="vehicle">Select Vehicle *</label>
                            <ClassetDropdown
                                id="vehicle"
                                optionLabel="label"
                                optionValue="value"
                                value={selectedVehicleId}
                                options={vehicleDropdown}
                                onChange={(e) => this.setState({ selectedVehicleId: e.value })}
                                placeholder="Select Vehicle"
                            />
                        </div>

                        <div className="field mb-3">
                            <label htmlFor="startDate">Start Date</label>
                            <ClassetCalendar
                                id="startDate"
                                calendarMode="single"
                                value={startDate}
                                onChange={(e) => this.setState({ startDate: e.target.value })}
                                placeholder="Select Start Date"
                            />
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    visible={showChangeDialog}
                    style={{ width: '450px' }}
                    header="Change Vehicle for Route"
                    modal
                    footer={this.renderChangeDialogFooter()}
                    onHide={() => this.setState({ showChangeDialog: false })}
                >
                    <div className="p-fluid">
                        <div className="mb-3 p-3 surface-100 border-round">
                            <p className="text-600 mb-2">Current Services</p>
                            {currentServices && currentServices.length > 0 ? (
                                currentServices.map((service, index) => (
                                    <p key={service._id || index} className="font-bold mb-1">
                                        {index + 1}. {service.serviceName} - {service.vehicle?.vehicleRegistrationNo || 'N/A'}
                                    </p>
                                ))
                            ) : (
                                <p className="font-bold">No services created</p>
                            )}
                        </div>

                        <div className="field mb-3">
                            <label htmlFor="newVehicle">Select New Vehicle *</label>
                            <ClassetDropdown
                                id="newVehicle"
                                optionLabel="label"
                                optionValue="value"
                                value={selectedVehicleId}
                                options={vehicleDropdown}
                                onChange={(e) => this.setState({ selectedVehicleId: e.value })}
                                placeholder="Select New Vehicle"
                            />
                        </div>

                        <div className="field mb-3">
                            <label htmlFor="changeDate">Change Date</label>
                            <ClassetCalendar
                                id="changeDate"
                                calendarMode="single"
                                value={startDate}
                                onChange={(e) => this.setState({ startDate: e.target.value })}
                                placeholder="Select Change Date"
                            />
                        </div>
                    </div>
                </Dialog>
            </>
        );
    }
}

export default RouteVehicleAssignment;
